/* eslint-disable @typescript-eslint/no-explicit-any */
import { Middleware } from '@reduxjs/toolkit'

import { RootState } from './reducer'

interface PersistConfig {
  selector: (state: RootState) => any
  storageKey: string
  perUser?: boolean
  fallback?: any
  isHydratedSelector?: (state: RootState) => boolean
}

export function createPersistMiddleware({
  selector,
  storageKey,
  perUser,
  fallback = null,
  isHydratedSelector,
}: PersistConfig): Middleware<unknown, RootState> {
  return (store) => (next) => (action) => {
    const result = next(action)

    const state = store.getState()

    if (isHydratedSelector && !isHydratedSelector(state)) {
      return result
    }

    const userId = state.tokens.currentUser?.id

    if (perUser && !userId) {
      return result
    }

    const key = perUser && userId ? `${storageKey}_${userId}` : storageKey
    const value = selector(state) ?? fallback

    localStorage.setItem(key, JSON.stringify(value))

    return result
  }
}

// interface PersistConfig {
//   actionMatcher: (action: any) => boolean
//   selector: (state: RootState) => any
//   storageKey: string
//   fallback: any
// }

// export function createPersistMiddleware({
//   actionMatcher,
//   selector,
//   storageKey,
//   fallback,
// }: PersistConfig): Middleware<unknown, RootState> {
//   return (store) => (next) => (action) => {
//     const result = next(action)

//     if (actionMatcher(action)) {
//       const value = selector(store.getState()) ?? fallback
//       localStorage.setItem(storageKey, JSON.stringify(value))
//     }

//     return result
//   }
// }
